// extracted by mini-css-extract-plugin
module.exports = {"container":"_5072e332","searchTerm":"_a872c5d5"};